import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";

import { ConsultantsService } from "../../services/consultants.service";
import { TAAConstants } from "../../../../../views/constants/taa-constants";
import { LandingService } from "../../../../../views/services/landing.service";
import { User } from "../../../../../views/services/user.model";
import { AppService } from "../../../../../views/services/app.service";

@Component({
  templateUrl: "./analysts.component.html",
  styleUrls: ["./analysts.component.css"]
})
export class AnalystsComponent implements OnInit {
  public consultants: any = {};
  public consultantId: any;
  public userDetails: User;
  public analyst: any = {};
  public consultantTypes: Array<any> = [];
  public consultantStatuses: Array<any> = [];
  public consultantForm: any;
  public popUpType: string;
  public display: string;
  public userNmErr: string;
  public firstNmErr: string;
  public lastNmErr: string;
  public emailErr: string;
  public statusErr: string;
  public msg: string;

  constructor(
    private analystsService: ConsultantsService,
    private appService: AppService,
    public taaConstants: TAAConstants,
    public landingService: LandingService
  ) { }

  ngOnInit() {
    this.consultants = [];
    this.consultantStatuses = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" },
      { id: "", code: "Please Select" }
    ];
    this.consultantTypes = ["INTERNAL", "EXTERNAL"];
    this.appService.getUserProfile().then(user => this.userDetails = user);
    this.loadAnalyst("");
  }
  loadAnalyst(type) {
    this.analystsService.getConsultants().subscribe(resp => {
      this.consultants = resp;
    });
    if (type === "close") {
      this.display = "none";
    }
  }

  openPopup(item, type) {
    this.popUpType = type;
    if (this.popUpType === "Edit") {
      this.analyst.USER_NM = item.USER_NM;
      this.analyst.CONSULTANT_TYPE_DS = item.CONSULTANT_TYPE_DS;
      this.analyst.CONSULTANT_ID = item.CONSULTANT_ID;
      this.analyst.FIRST_NM = item.FIRST_NM;
      this.analyst.LAST_NM = item.LAST_NM;
      this.analyst.EMAIL_AD = item.EMAIL_AD;
      this.analyst.STATUS_CD = item.STATUS_CD;
      if (this.analyst.STATUS_CD === "Inactive") {
        this.analyst.STATUS_CD = "I";
      } else if (this.analyst.STATUS_CD === "Active") {
        this.analyst.STATUS_CD = "A";
      }
    } else {
      this.analyst.USER_NM = "";
      this.analyst.FIRST_NM = "";
      this.analyst.LAST_NM = "";
      this.analyst.EMAIL_AD = "";
      this.analyst.CONSULTANT_TYPE_DS = "INTERNAL";
      this.analyst.STATUS_CD = "";
    }

    this.display = "block";
  }

  closePopUpForm() {
    this.resetForm();
    this.display = "none";
  }
  addRow() {
    let addRow: boolean = false;
    addRow = this.validateAddForm();
    if (addRow) {
      this.analyst.USER_NM = this.analyst.USER_NM.toUpperCase();
      this.analystsService.addAnalyst(this.analyst).subscribe(
        resp => {
          if (resp) {
            this.msg = "Analyst has been added successfully.";
            this.loadAnalyst("close");
          }
        },
        err => {
          if (err.error.error.message.includes("USER_NM")) {
            this.userNmErr = "Username is not valid";
          } else if (err.error.error.message.includes("FIRST_NM")) {
            this.firstNmErr = "First Name is not valid";
          } else if (err.error.error.message.includes("LAST_NM")) {
            this.lastNmErr = "Last Name is not valid";
          } else if (err.error.error.message.includes("EMAIL_AD")) {
            this.emailErr = "Email Address is not valid";
          }
        }
      );
    }
  }

  validateAddForm() {
    const emptyOrOnlyWhiteSpace = this.taaConstants.getEmptySpaceRegEx();

    if (
      !this.analyst.USER_NM ||
      this.analyst.USER_NM === null ||
      this.analyst.USER_NM === ""
    ) {
      this.userNmErr = "Username is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.USER_NM)) {
        const pattern = /^[\/a-zA-Z0-9\@\_\-\/\(\)\.\,\=\/]{1,50}$/;
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.USER_NM)) {
          const duplicateUserName = this.consultants.some(
            item =>
              item.USER_NM.toUpperCase() === this.analyst.USER_NM.toUpperCase()
          );
          if (duplicateUserName) {
            this.userNmErr = "Username must be Unique";
          } else {
            this.userNmErr = "";
          }
        } else {
          this.userNmErr = "Username is not valid";
        }
      } else {
        this.userNmErr = "Username is required";
      }
    }
    if (!this.analyst.FIRST_NM) {
      this.firstNmErr = "First Name is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.FIRST_NM)) {
        const pattern = this.taaConstants.getNAME_RegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.FIRST_NM)) {
          this.firstNmErr = "";
        } else {
          this.firstNmErr = "First Name is not valid";
        }
      } else {
        this.firstNmErr = "First Name is required";
      }
    }

    if (!this.analyst.LAST_NM) {
      this.lastNmErr = "Last Name is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.LAST_NM)) {
        const pattern = this.taaConstants.getNAME_RegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.LAST_NM)) {
          this.lastNmErr = "";
        } else {
          this.lastNmErr = "Last Name is not valid";
        }
      } else {
        this.lastNmErr = "Last Name is required";
      }
    }
    if (!this.analyst.EMAIL_AD) {
      this.emailErr = "Email Address is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.EMAIL_AD)) {
        const pattern = this.taaConstants.getAnalystEmailRegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.EMAIL_AD)) {
          this.emailErr = "";
        } else {
          this.emailErr = "Email Address is not valid";
        }
      } else {
        this.emailErr = "Email Address is required";
      }
    }
    if (!this.analyst.STATUS_CD) {
      this.statusErr = "Status is required";
    } else {
      this.statusErr = "";
    }
    if (
      this.userNmErr ||
      this.firstNmErr ||
      this.lastNmErr ||
      this.statusErr ||
      this.emailErr
    ) {
      return false;
    } else {
      return true;
    }
  }
  editRow() {
    let editRow: boolean = false;
    editRow = this.validateEditForm();
    if (editRow) {
      if (this.analyst.STATUS_CD === "I") {
        this.landingService
          .getInternalScreenData("myRequests", this.analyst.CONSULTANT_ID)
          .subscribe((response: any) => {
            if (response.body.length > 0) {
              this.statusErr =
                "Cannot Inactivate. Requests are assigned to this Analyst for review.";
            } else {
              this.saveEditRow();
            }
          });
      } else {
        this.saveEditRow();
      }
    }
  }
  saveEditRow() {
    this.analystsService.editAnalyst(this.analyst).subscribe(
      res => {
        if (res) {
          this.msg = "All your changes have been saved.";
          this.loadAnalyst("close");
        }
      },
      err => {
        if (err.error.error.message.includes("FIRST_NM")) {
          this.firstNmErr = "First Name is not valid";
        } else if (err.error.error.message.includes("LAST_NM")) {
          this.lastNmErr = "Last Name is not valid";
        } else if (err.error.error.message.includes("EMAIL_AD")) {
          this.emailErr = "Email Address is not valid";
        }
      }
    );
  }
  validateEditForm() {
    const emptyOrOnlyWhiteSpace = this.taaConstants.getEmptySpaceRegEx();
    if (!this.analyst.FIRST_NM) {
      this.firstNmErr = "First Name is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.FIRST_NM)) {
        const pattern = this.taaConstants.getNAME_RegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.FIRST_NM)) {
          this.firstNmErr = "";
        } else {
          this.firstNmErr = "First Name is not valid";
        }
      } else {
        this.firstNmErr = "First Name is required";
      }
    }

    if (!this.analyst.LAST_NM) {
      this.lastNmErr = "Last Name is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.LAST_NM)) {
        const pattern = this.taaConstants.getNAME_RegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.LAST_NM)) {
          this.lastNmErr = "";
        } else {
          this.lastNmErr = "Last Name is not valid";
        }
      } else {
        this.lastNmErr = "Last Name is required";
      }
    }
    if (!this.analyst.EMAIL_AD) {
      this.emailErr = "Email Address is required";
    } else {
      if (emptyOrOnlyWhiteSpace.test(this.analyst.EMAIL_AD)) {
        const pattern = this.taaConstants.getAnalystEmailRegEx();
        const regex = new RegExp(pattern);
        if (regex.test(this.analyst.EMAIL_AD)) {
          this.emailErr = "";
        } else {
          this.emailErr = "Email Address is not valid";
        }
      } else {
        this.emailErr = "Email Address is required";
      }
    }
    if (!this.analyst.STATUS_CD) {
      this.statusErr = "Status is required";
    } else {
      this.statusErr = "";
    }
    if (this.firstNmErr || this.lastNmErr || this.statusErr || this.emailErr) {
      return false;
    } else {
      return true;
    }
  }

  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }
  resetForm() {
    this.msg = "";
    this.userNmErr = "";
    this.emailErr = "";
    this.statusErr = "";
    this.firstNmErr = "";
    this.lastNmErr = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/analysts/analysts.component.ts